import { observable, action } from 'mobx';
import { dispatch } from 'rfx-core';

import { getStore } from '#/shared/getStores';
import { SSMLogger, getChildLogger } from '#/shared/utils/client.logger';

const log = getChildLogger('AgendaProgressLoadingModal');
export default class AgendaProgressLoadingModal {
  @observable
  message = null;

  @observable
  isOpen = false;

  @observable
  agendaJobProgress = null;

  @observable
  agendaJobProgressId = null;

  @observable
  openedAt = null;

  timeoutHandle: NodeJS.Timeout;

  private log: SSMLogger;

  @action
  open({ message = null } = {}) {
    this.message = message;
    this.isOpen = true;
    this.openedAt = new Date();

    this.getAgendaJobProgress();

    this.pollAgendaJobProgress();
  }

  @action.bound
  async getAgendaJobProgress() {
    const store = getStore('agendaJobProgress');
    if (store.selected?.uuid) {
      await store.get(store.selected.uuid);
    }
    this.agendaJobProgress = store.selected;
    this.agendaJobProgressId = this.agendaJobProgress?.uuid || null;
    log.info('AgendaJobProgress ID:' + this.agendaJobProgressId);
  }

  @action.bound
  setMessage(message: string) {
    this.message = message;
  }

  @action.bound
  async pollAgendaJobProgress() {
    await this.getAgendaJobProgress();

    log.info(
      `Waiting for agendaJobProgress to complete (${
        this.agendaJobProgress?.status || 'unknown'
      })`,
      {
        agendaJobProgress: this.agendaJobProgress,
      },
    );

    if (
      this.agendaJobProgress?.status === 'running' ||
      this.agendaJobProgress?.status === 'pending' ||
      !this.agendaJobProgress?.uuid
    ) {
      if (this.timeoutHandle) {
        clearTimeout(this.timeoutHandle);
      }
      this.timeoutHandle = setTimeout(() => {
        log.info('Polling agendaJobProgress');
        this.pollAgendaJobProgress();
      }, 5000);
    } else if (this.agendaJobProgress?.status === 'complete') {
      if (!this.isOpen) {
        getStore('ui.snackBar').render({
          messageType: this.agendaJobProgress.errorMsg ? 'error' : 'info',
          props: {
            description: this.agendaJobProgress.errorMsg,
            header:
              'AgendaJob Completed' +
              (this.agendaJobProgress.errorMsg ? ' with errors' : ''),
          },
        });
      }
      if (this.agendaJobProgress.errorMsg && this.isOpen) {
        this.setMessage('Job Completed with errors');
      } else {
        this.close({ delay: 5000, message: 'Job Completed' });
      }
    }
  }

  @action
  completeInBackground() {
    this.isOpen = false;
  }

  @action
  close({ delay = 0, message = null } = {}) {
    setTimeout(
      action(() => {
        dispatch('agendaJobProgress.clearSelected');
        this.isOpen = false;
        this.message = null;
        this.openedAt = null;
      }),
      delay,
    );
    this.setMessage(message || null);
  }
}
